import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { ServerInterface, setEditId, setEditError, selectServerById } from "src/store/mine_craft/serversSlice";
import { updateServer, fetchServer } from "src/actions/mine_craft/serversActions";
import { objToFormData } from "src/helpers/FormHelper";

import DrawerRight from "src/componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "src/componets/AlertBlock";

const Edit = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const id: any = useAppSelector(state => state.mineCraft.servers.editId);
  const error = useAppSelector(state => state.mineCraft.servers.editError);
  const server = useAppSelector(state => id ? selectServerById(state, id) : undefined);
  const params: any = { ...server };

  useEffect(() => {
    if (id) {
      dispatch(fetchServer(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(rawData: any) {
    handleSave(rawData).catch(console.error);
  }

  async function handleSave(data: ServerInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updateServer({ id, data: formData }));

    if (updateServer.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-server'>
        <h6 className="v-content-label">Edit Server</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={params} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
